var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
// @ts-expect-error - TS7016 - Could not find a declaration file for module 'uuid/v4'. '/Users/dkrajnak/workspace/aviso/sse-frontend/react/node_modules/uuid/v4.js' implicitly has an 'any' type.
import uuid from "uuid/v4";
import { useFormContext } from "react-hook-form";
import SurveyService from "../../../../Services/Survey.service";
import FAIcon from "../../../UI/FAIcon/FAIcon";
import PersonService from "../../../../Services/Person.service";
import SelectSurveyForm from "../../Survey/SelectSurveyForm";
import { SYSTEM_USER_ID } from "../../../Hooks/useSystemUser";
import SelectAsyncField from "../../../Form/SelectAsyncField";
export const SEND_SURVEY_GET_CRITERIA = (formState, { exportNodeId, pipelineId }) => {
    const PERSON_LOADER_DELEGATE_ID = uuid();
    const personLoaderDelegate = {
        id: PERSON_LOADER_DELEGATE_ID,
        type: "PersonLoader",
        criteria: {
            personId: {
                isReference: true,
                workflowNodeReferenceId: exportNodeId,
                propertyName: "studentId",
            },
        },
    };
    const OPPORTUNITY_LOADER_DELEGATE_ID = uuid();
    const opportunityLoaderDelegate = {
        id: OPPORTUNITY_LOADER_DELEGATE_ID,
        type: "OpportunityLoader",
        criteria: {
            subjectId: {
                isReference: true,
                workflowNodeReferenceId: exportNodeId,
                propertyName: "studentId",
            },
            pipelineId: {
                isReference: false,
                value: pipelineId,
            },
        },
    };
    return {
        delegates: [personLoaderDelegate, opportunityLoaderDelegate],
        criteria: {
            surveyId: {
                value: formState.survey.id,
                isReference: false,
            },
            // @ts-expect-error - TS2339 - Property 'isReference' does not exist on type 'PersonLite | { isReference: true; }'.
            senderPersonId: formState.sender.isReference
                ? {
                    isReference: true,
                    workflowNodeReferenceId: OPPORTUNITY_LOADER_DELEGATE_ID,
                    propertyName: "assignedToPersonId",
                }
                : {
                    // @ts-expect-error - TS2339 - Property 'personId' does not exist on type 'PersonLite | { isReference: true; }'.
                    value: formState.sender.personId,
                    isReference: false,
                },
            recipientPersonId: {
                isReference: true,
                workflowNodeReferenceId: PERSON_LOADER_DELEGATE_ID,
                propertyName: "personId",
            },
            pipelineId: {
                value: pipelineId,
                isReference: false,
            },
        },
    };
};
// @ts-expect-error - TS2322 - Type '(criteria: { senderPersonId: WorkflowGroupNodeCriteriaProperty; surveyId: WorkflowGroupNodeCriteriaProperty; }) => Promise<...>' is not assignable to type 'GetFormState<{ senderPersonId: WorkflowGroupNodeCriteriaProperty; surveyId: WorkflowGroupNodeCriteriaProperty; }, SendSurveyWorkflowNodeDefinitionFormState>'.
export const SEND_SURVEY_GET_FORM_STATE = (criteria) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const [sender, survey] = yield Promise.all([
            criteria.senderPersonId.isReference
                ? Promise.resolve({
                    isReference: true,
                    personId: null,
                })
                : PersonService.getPeopleByPersonId([
                    criteria.senderPersonId.value,
                ]).then((people) => people[0]),
            yield SurveyService.get(criteria.surveyId.value),
        ]);
        return {
            sender,
            survey,
        };
    }
    catch (_a) {
        throw new Error("This automation uses surveys, which you do not have permission to use. Please see your administrator.");
    }
});
const SendSurveyWorkflowNodeDefinitionForm = ({ name, }) => {
    const useFormProps = useFormContext();
    return (_jsxs(_Fragment, { children: [_jsx(SelectAsyncField, { labelKey: "fullName", valueKey: "personId", label: "Sender", name: name ? name + ".sender" : "sender", loadOptions: (search) => __awaiter(void 0, void 0, void 0, function* () {
                    return [
                        {
                            isReference: true,
                            personId: null,
                            fullName: "Assigned Person",
                        },
                        // This is a ludicrus, hacky type to let us add the magic "Assigned Person" option.  It shouldn't
                        // be done like this, but we don't have time to make it better now
                    ]
                        .concat(yield PersonService.getPeopleByPersonId(SYSTEM_USER_ID).then((people) => people[0]))
                        .concat(yield PersonService.searchMessageRecipients(search));
                }), optionRenderer: (option) => {
                    // @ts-expect-error - TS2339 - Property 'isReference' does not exist on type '{ personId: any; }'.
                    if (option.isReference) {
                        return (_jsxs("div", { className: "d-flex align-items-center", children: [_jsx(FAIcon, { type: "fas", icon: "magic", addMarginRight: true }), _jsx("strong", { children: "Assigned Person" }), "\u00A0\u2013 Send as the person this opportunity is assigned to"] }));
                    }
                    if (option.personId === SYSTEM_USER_ID) {
                        return (_jsxs("div", { className: "d-flex align-items-center", children: [_jsx(FAIcon, { type: "fas", icon: "magic", addMarginRight: true }), _jsx("strong", { children: "System User" }), "\u00A0\u2013 Send as the system user"] }));
                    }
                    // @ts-expect-error - TS2339 - Property 'fullName' does not exist on type '{ personId: any; }'. | TS2339 - Property 'studentId' does not exist on type '{ personId: any; }'.
                    return `${option.fullName} (${option.studentId})`;
                }, required: true }), _jsx(SelectSurveyForm, Object.assign({ name: name }, useFormProps))] }));
};
export default SendSurveyWorkflowNodeDefinitionForm;
